<template>
<div class="clearfix">
    <div class="container">
        <el-card class="card">
            <img class="logo" src="../../../static/image/logo.png"/>
            <div class="item-column">
                <span class="span-hint" v-show="!phone_status">{{phone_hint}}</span>
                <el-input placeholder="请输入手机号" size="medium" v-model="phone" @blur='phoneOnBlur' maxlength=11 @keyup.enter.native="login" clearable autocomplete="on"></el-input>
            </div>
            <div class="item-column">
                <span class="span-hint" v-show="!verify_status">{{verify_hint}}</span>
                <div class="item-row">
                    <el-input placeholder="输入验证码" size="medium" v-model="verify_code" @blur='verifyOnBlur' maxlength=11 @keyup.enter.native="login"  clearable></el-input>
                    <el-button class="btn-verify" size="medium" @click="getVerifyCode" type="primary" :loading="vloading" :disabled="verify_disable">{{btn_verify}}</el-button>
                </div>
            </div>
            <div class="item-column">
                <el-button class="btn-confirm" size="medium" type="primary" :loading='loading' @click="login">绑定</el-button>
            </div>
        </el-card>
    </div>
</div>
</template>
<script>
import utils from '@/js/utils.js'
export default {
    data () {
        return {
            phone_hint:'请输入手机号',
            phone_status:true,
            phone:'',
            verify_hint:'请输入验证码',
            verify_status:true,
            verify_code:'',
            btn_verify:'获取验证码',
            verify_disable:false,
            verify_second:60,
            loading:false,
            vloading:false,
            wxCode:''
        }
    },
    created () {
      var code = this.$route.query.code
      if(!this.utils.isEmptyStr(code)){
        this.wxCode = code
      }
    },
    methods:{
        getVerifyCode(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请先填写手机号',
                    type: 'fail'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请先填写正确的手机号',
                    type: 'fail'
                });
                return
            }
            var codeParams = {
                telephone:this.phone,
                phoneMd5:this.$md5(this.phone),
                type:'wxbind'
            }
            this.vloading = true
            this.wjtHttp.get(this,'/api/smsCode',codeParams,false,(res)=>{
                this.vloading = false
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message:'发送成功',
                        type:'success'
                    })
                    this.verify_disable = true
                    clearInterval(this.mInterval)
                    this.mInterval = setInterval(() => {
                        if(this.verify_second == 0){
                            this.verify_disable = false
                            this.verify_second = 60
                            clearInterval(this.mInterval)
                            return
                        }
                        this.verify_second--
                    }, 1000);
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                this.vloading = false
            })
        },
        phoneOnBlur(){
            if(this.phone.length == 0){
                this.phone_status = false
                this.phone_hint='请输入手机号码'
            }else if(this.phone.length < 11 || this.phone.length > 11){
                this.phone_status = false
                this.phone_hint='请输入正确的手机号码'
            }else{
                this.phone_status = true
            }
        },
        verifyOnBlur(){
            if(this.verify_code.length == 0){
                this.verify_status = false
                this.verify_hint='请输入验证码'
            }else{
                this.verify_status = true
            }
        },
        login(){
            if(this.phone.length == 0){
                this.phone_status = false
                this.phone_hint='请输入手机号码'
                return
            }
            if(this.phone.length < 11 || this.phone.length > 11){
                this.phone_status = false
                this.phone_hint='请输入正确的手机号码'
                return
            }
          if(this.verify_code.length == 0){
              this.verify_status = false
              this.verify_hint='请输入验证码'
              return
          }
          var vParams = {
              wxCode:this.wxCode,
              code:this.verify_code,
              username:this.phone,
              phoneMd5:this.$md5(this.phone),
              type:'pc'
          }
          this.loading = true
          this.wjtHttp.post(this,'/api/wechat/v1/bind',vParams,false,(res)=>{
              var data = res.data
              if(data.code == 200){
                  this.$cookies.set('token',data.token,{expires:1})
                  this.wjtHttp.get(this,'/api/getInfo',{},false,(res)=>{
                      this.loading = false
                      var infoData = res.data
                      if(infoData.code == 200){
                          this.$store.commit('updateUserInfo',infoData)
                          if(data.pwdNotSet == false){
                              this.$router.replace('/SetPassword')
                          }else{
                              this.$message({
                                  message: '登录成功',
                                  type: 'success'
                              });
                              this.$router.replace('/')
                          }
                      }else{
                          this.$message({
                              message:(infoData.msg&&infoData.msg.length > 0)?infoData.msg:'服务异常，请联系管理员',
                              type:'error'
                          })
                      }
                  },(err)=>{
                      this.loading = false
                  })
              }else{
                  this.loading = false
                  this.$message({
                      message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                      type:'error'
                  })
              }
          },(err)=>{
              this.loading = false
          })
        }
    },
    watch:{
        verify_disable:function(val){
            if(val){
                this.btn_verify = this.verify_second+'后重发'
            }else{
                this.btn_verify = '获取验证码'
            }
        },
        verify_second:function(val){
            if(val < 60){
                this.btn_verify = val + '后重发'
            }
        }
    }
}
</script>
<style scoped>
    .container{
        margin: 0 auto;
        position: relative;
    }
    .clearfix:after, .clearfix:before {
        content: " ";
        display: table;
    }
    .card{
        margin: 30px auto;
        padding: 3% 3%;
        background-color: #fff;
        max-width: 375px;
        width: 100%;
    }
    .card>img{
        width: 80px;
        height: 80px;
    }
    .logo{
        margin-bottom: 30px;
    }
    .span-hint{
        font-size: 16px;
        color: #ff5a05;
        padding: 10px 0;
        text-align: left;
    }
    .item-column{
        display: flex;
        flex-direction: column;
        margin-bottom: 32px;
    }
    .item-row{
        display: flex;
        flex-direction: row;
    }
    .btn-verify{
        margin-left: 18px;
    }
    .span-password-login{
        width: 90px;
        height: 100%;
        font-size: 16px;
        color: #FE9400;
        text-align: right;
        cursor: pointer;
    }
    .span-change-verify{
        font-size: 16px;
        color: #FE9400;
        text-align: center;
        padding: 8px 0;
        cursor: pointer;
    }
    .btn-confirm{
        width: 100%;
        height: 45px;
        margin-top: 82px;
    }
    .span-third-login{
        font-size: 16px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        color: #333333;
    }
    .img-wx{
        width: 36px;
        height: 36px;
        margin-top: 20px;
        position: relative;
        cursor: pointer;
        margin-left: calc(50% - 16px);
    }
    .span-signup-text{
        width: calc(100% - 90px);
        font-size: 16px;
        text-align: left;
        color: #333333;
        display: flex;
        align-items: center;
    }
    .span-signup-text>span{
        font-size: 16px;
        color: #FE9400;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/account/Bind.vue